export const helpCenterKeys = {
  getAllArticles: (companyId: string) => ['all-articles', companyId],
};
